import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";

interface UnauthorizedPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  planName: string;
  planPrice: number;
}

const UnauthorizedPlanModal: React.FC<UnauthorizedPlanModalProps> = ({
  isOpen,
  onClose,
  planName,
  planPrice,
}) => {
  const navigate = useNavigate();
  const { setSelectedPlan } = useCart();

  if (!isOpen) return null;

  const handleLogin = () => {
    // Store plan selection in context and localStorage
    const plan = {
      name: planName,
      price: planPrice,
      timestamp: Date.now(),
    };

    setSelectedPlan(plan);
    localStorage.setItem("selectedPlan", JSON.stringify(plan));

    // Redirect to login with return URL
    navigate("/login?returnUrl=/planes");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div className="flex justify-between items-start">
          <h2 className="text-2xl font-bold text-gray-900">
            Iniciar Sesión Requerido
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500">
            <span className="sr-only">Cerrar</span>
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mt-4">
          <p className="text-gray-600">
            Para suscribirte al Plan {planName} por $
            {planPrice.toLocaleString()}/mes, necesitas iniciar sesión primero.
          </p>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          <button
            onClick={handleLogin}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors">
            Iniciar Sesión
          </button>
          <button
            onClick={onClose}
            className="w-full border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-50 transition-colors">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPlanModal;
